var _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeToQroqin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,6,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,6,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,6,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,18,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,18,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,18,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,18,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,18,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,18,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,18,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,30,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,30,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,30,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,30,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,30,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,42,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,42,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,42,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,42,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,42,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,54,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,54,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,54,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,54,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,66,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,66,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,66,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,78,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,78,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,78,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,78,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,78,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,90,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,90,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,90,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,90,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,90,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,90,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,90,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,102,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 24,
    width: 12,
    height: 12,
    transform: "rotate(0,102,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 72,
    width: 12,
    height: 12,
    transform: "rotate(0,102,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,102,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,102,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,102,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,102,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,102,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,102,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,102,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,102,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,102,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 0,
    width: 12,
    height: 12,
    transform: "rotate(0,114,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,114,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 48,
    width: 12,
    height: 12,
    transform: "rotate(0,114,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 84,
    width: 12,
    height: 12,
    transform: "rotate(0,114,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,114,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,114,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,114,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,114,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,114,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,114,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 276,
    width: 12,
    height: 12,
    transform: "rotate(0,114,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,114,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 0,
    width: 12,
    height: 12,
    transform: "rotate(0,126,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,126,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 12,
    height: 12,
    transform: "rotate(0,126,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 72,
    width: 12,
    height: 12,
    transform: "rotate(0,126,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,126,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,126,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,126,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,126,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,126,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,126,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,126,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,126,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,126,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,126,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 264,
    width: 12,
    height: 12,
    transform: "rotate(0,126,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,126,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,138,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 60,
    width: 12,
    height: 12,
    transform: "rotate(0,138,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,138,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,138,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,138,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,138,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,138,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,138,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,138,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,138,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 0,
    width: 12,
    height: 12,
    transform: "rotate(0,150,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 24,
    width: 12,
    height: 12,
    transform: "rotate(0,150,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 36,
    width: 12,
    height: 12,
    transform: "rotate(0,150,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 72,
    width: 12,
    height: 12,
    transform: "rotate(0,150,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 84,
    width: 12,
    height: 12,
    transform: "rotate(0,150,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,150,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,150,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,150,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,150,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,150,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,162,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 36,
    width: 12,
    height: 12,
    transform: "rotate(0,162,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 48,
    width: 12,
    height: 12,
    transform: "rotate(0,162,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,162,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,162,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,162,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,162,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,162,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,162,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,162,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,162,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 276,
    width: 12,
    height: 12,
    transform: "rotate(0,162,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,162,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 0,
    width: 12,
    height: 12,
    transform: "rotate(0,174,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,174,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 36,
    width: 12,
    height: 12,
    transform: "rotate(0,174,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 60,
    width: 12,
    height: 12,
    transform: "rotate(0,174,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 72,
    width: 12,
    height: 12,
    transform: "rotate(0,174,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,174,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,174,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,174,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,174,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 264,
    width: 12,
    height: 12,
    transform: "rotate(0,174,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,174,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 60,
    width: 12,
    height: 12,
    transform: "rotate(0,186,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,186,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,186,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,186,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,186,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,186,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,186,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,186,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,186,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,186,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 0,
    width: 12,
    height: 12,
    transform: "rotate(0,198,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(0,198,18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 48,
    width: 12,
    height: 12,
    transform: "rotate(0,198,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 60,
    width: 12,
    height: 12,
    transform: "rotate(0,198,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 72,
    width: 12,
    height: 12,
    transform: "rotate(0,198,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 84,
    width: 12,
    height: 12,
    transform: "rotate(0,198,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,198,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,198,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,198,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,198,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,198,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,198,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,198,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,198,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,198,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 276,
    width: 12,
    height: 12,
    transform: "rotate(0,198,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,210,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,210,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,210,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,210,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,210,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,210,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,222,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,222,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,222,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,222,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,222,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,222,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,222,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,222,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,222,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,234,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,234,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,234,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,234,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,234,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,234,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 276,
    width: 12,
    height: 12,
    transform: "rotate(0,234,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,234,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,246,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,246,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,246,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,246,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,246,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,246,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,246,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,258,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,258,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,258,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,258,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,258,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 204,
    width: 12,
    height: 12,
    transform: "rotate(0,258,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,258,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 264,
    width: 12,
    height: 12,
    transform: "rotate(0,258,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,270,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,270,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,270,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,270,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,270,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,270,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,270,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,270,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,270,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 276,
    width: 12,
    height: 12,
    transform: "rotate(0,270,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,270,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 96,
    width: 12,
    height: 12,
    transform: "rotate(0,282,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,282,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 120,
    width: 12,
    height: 12,
    transform: "rotate(0,282,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,282,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,282,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,282,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,282,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 228,
    width: 12,
    height: 12,
    transform: "rotate(0,282,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 240,
    width: 12,
    height: 12,
    transform: "rotate(0,282,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 108,
    width: 12,
    height: 12,
    transform: "rotate(0,294,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 132,
    width: 12,
    height: 12,
    transform: "rotate(0,294,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 144,
    width: 12,
    height: 12,
    transform: "rotate(0,294,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 156,
    width: 12,
    height: 12,
    transform: "rotate(0,294,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 168,
    width: 12,
    height: 12,
    transform: "rotate(0,294,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 180,
    width: 12,
    height: 12,
    transform: "rotate(0,294,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 12,
    height: 12,
    transform: "rotate(0,294,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 216,
    width: 12,
    height: 12,
    transform: "rotate(0,294,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 252,
    width: 12,
    height: 12,
    transform: "rotate(0,294,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 288,
    width: 12,
    height: 12,
    transform: "rotate(0,294,294)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 0 0v 84h 84v -84zM 12 12h 60v 60h -60z",
    transform: "rotate(0,42,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 36,
    height: 36,
    transform: "rotate(0,42,42)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 216 0v 84h 84v -84zM 228 12h 60v 60h -60z",
    transform: "rotate(90,258,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 24,
    width: 36,
    height: 36,
    transform: "rotate(90,258,42)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 0 216v 84h 84v -84zM 12 228h 60v 60h -60z",
    transform: "rotate(-90,42,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 240,
    width: 36,
    height: 36,
    transform: "rotate(-90,42,258)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeToQroqin);
export default __webpack_public_path__ + "static/media/welcome_to_qroq.in.fd2b66f3d7b01ea14e61bd839ef9ee1a.svg";
export { ForwardRef as ReactComponent };